var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { profileServiceMainDataSelector } from 'common/services/profile-service/service-store/selectors';
import { useProfileStore } from 'common/services/profile-service/service-store/service-store';
import { UserAvatar } from 'ui-kit/user-avatar';
import { checkEqual } from 'common/helpers/checkEqual';
export var CurrentUserAvatar = function (_a) {
    var props = __rest(_a, []);
    var _b = useProfileStore(profileServiceMainDataSelector, checkEqual), firstName = _b.firstName, lastName = _b.lastName, image = _b.image;
    return _jsx(UserAvatar, __assign({ firstName: firstName, lastName: lastName, imagePath: image === null || image === void 0 ? void 0 : image.fullPath }, props));
};
